import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from 'rxjs';

export interface IErrorService {
	get(unitId: string | number): Promise<any>;
	getNotifications(): Promise<any>;
	setNotificationShown(notificationId: string | number): void;
}

@Injectable({ providedIn: 'root' })
export class ErrorService implements IErrorService {
	//static $inject = ['$http'];
	private http = inject(HttpClient);
	constructor() {
	}

	get(unitId: string | number): Promise<any[]> {
		return firstValueFrom(this.http.get<any[]>(`/api/Alarm/get/${unitId}`));
	}

	getNotifications(): Promise<any[]> {
		return firstValueFrom(this.http.get<any[]>('/api/InAppNotification/getForCurrentUser'));
	}

	setNotificationShown(notificationId: string | number): void {

	}
}

// angular.module('errorModule').factory('ErrorService', downgradeInjectable(ErrorService));
